export const buildInfo = {
  version: "1.0.406",
  branch: "main",
  commit: "78c95daf",
  timestamp: "2026-03-14T14:37:38Z",
};
